"use client";

import React from "react";
import { Instagram, Mail, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="163740" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-none" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false} className="justify-start max-w-full">
      <NavigationMenuList className="flex-col items-start space-y-2 space-x-0 gap-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="px-0 py-1 h-auto w-full justify-start text-muted-foreground hover:text-primary hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent data-[active=true]:text-primary font-mono text-xs uppercase tracking-wider transition-all duration-300">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="system-footer" className="dark bg-background text-foreground py-16 md:py-24 border-t border-primary/20 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.25)_50%),linear-gradient(90deg,rgba(255,0,0,0.06),rgba(0,255,0,0.02),rgba(0,0,255,0.06))] bg-[length:100%_2px,3px_100%]" />
      
      <div className="container mx-auto px-6 md:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          
          {}
          <div className="md:col-span-5 flex flex-col space-y-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="/img/inkrealm_logo_dark.png" alt="Tracy Vetter" className="h-7 w-auto object-contain brightness-125" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm font-mono tracking-tight">
              Author of The Poseidon Project. Navigating the depths of high-tech sci-fi thrillers through immersive storytelling and cinematic media.
            </p>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col space-y-6">
            <h3 className="text-xs font-sans font-bold tracking-[0.25em] uppercase text-primary/80">
              Directives
            </h3>
            <MenuProvider menu_id="30">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4 flex flex-col space-y-6 md:items-end">
            <h3 className="text-xs font-sans font-bold tracking-[0.25em] uppercase text-primary/80 md:hidden">
              Transmission
            </h3>
            <div className="flex items-center gap-2 -ml-3 md:ml-0">
              <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary rounded-none hover:bg-primary/5 transition-all duration-300" asChild>
                <Link to="#" aria-label="Twitter">
                  <Twitter strokeWidth={1.5} className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary rounded-none hover:bg-primary/5 transition-all duration-300" asChild>
                <Link to="#" aria-label="Instagram">
                  <Instagram strokeWidth={1.5} className="size-5" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary rounded-none hover:bg-primary/5 transition-all duration-300" asChild>
                <Link to="#" aria-label="Email">
                  <Mail strokeWidth={1.5} className="size-5" />
                </Link>
              </Button>
            </div>
            
            <div className="mt-auto pt-8 md:pt-0 flex flex-col md:items-end space-y-2">
              <p className="text-muted-foreground text-[10px] font-mono uppercase tracking-[0.2em]">
                &copy; {currentYear} Tracy Vetter.
              </p>
              <p className="text-muted-foreground/40 text-[10px] font-mono uppercase tracking-[0.15em]">
                System Protocol: All rights reserved.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}